// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__7GWsw","rootSuccess":"CompleteLink_rootSuccess__VMTgl","rootFailure":"CompleteLink_rootFailure__3NgAs","isDisabled":"CompleteLink_isDisabled__2uqJA"};